
import { Course } from './types';
import {
  HOOKS_DEEP_DIVE_MODULE,
  CONTEXT_STATE_MODULE,
  ROUTER_NAVIGATION_MODULE,
  API_DATA_FETCHING_MODULE,
  PERFORMANCE_BASICS_MODULE,
  FORMS_VALIDATION_MODULE
} from './modules';

export const INTERMEDIATE_COURSE: Course = {
  id: "intermediate-react",
  title: "Intermediate React Development",
  description: "Master React hooks, state management, routing, and performance optimization to build production-ready applications.",
  level: "intermediate" as const,
  badge: "🚀 Intermediate",
  totalDuration: "10-12 hours",
  duration: "10-12 hours",
  estimatedHours: 11,
  imageSrc: "/placeholder.svg",
  requirements: [
    "Completion of Basic React course or equivalent knowledge",
    "Understanding of JavaScript ES6+ features",
    "Basic knowledge of HTML/CSS",
    "Familiarity with React components, props, and basic state"
  ],
  tags: ["React", "Hooks", "Router", "API", "Performance", "Forms"],
  learningOutcomes: [
    "Master React Hooks (useEffect, useContext, useReducer, custom hooks)",
    "Implement global state management with Context API",
    "Build navigation with React Router",
    "Handle API integration and data fetching patterns",
    "Optimize React applications for better performance",
    "Create robust forms with validation",
    "Apply React patterns and best practices"
  ],
  modules: [
    HOOKS_DEEP_DIVE_MODULE,
    CONTEXT_STATE_MODULE,
    ROUTER_NAVIGATION_MODULE,
    API_DATA_FETCHING_MODULE,
    PERFORMANCE_BASICS_MODULE,
    FORMS_VALIDATION_MODULE
  ],
  finalAssessment: {
    id: "intermediate-final",
    title: "Intermediate React Mastery Assessment",
    description: "Comprehensive assessment covering hooks, routing, state management, and performance optimization",
    questions: [
      {
        id: "q1",
        question: "Which hook would you use to perform side effects in functional components?",
        options: ["useState", "useEffect", "useContext", "useReducer"],
        correctAnswer: 1,
        difficulty: "easy"
      },
      {
        id: "q2",
        question: "What is the primary purpose of React.memo()?",
        options: ["To create memoized state", "To prevent unnecessary re-renders", "To cache API responses", "To optimize bundle size"],
        correctAnswer: 1,
        difficulty: "medium"
      },
      {
        id: "q3",
        question: "In React Router, which component is used to define route parameters?",
        options: ["<Route path='/user/:id'>", "<Param name='id'>", "<RouteParam>", "<PathVariable>"],
        correctAnswer: 0,
        difficulty: "medium"
      },
      {
        id: "q4",
        question: "What is the correct way to handle cleanup in useEffect?",
        options: ["Return undefined", "Return a cleanup function", "Call cleanup manually", "Use try-catch"],
        correctAnswer: 1,
        difficulty: "hard"
      },
      {
        id: "q5",
        question: "Which pattern is best for sharing state between distant components?",
        options: ["Prop drilling", "Context API", "Local storage", "Global variables"],
        correctAnswer: 1,
        difficulty: "medium"
      }
    ]
  }
};
